<template>
  <div v-if='taken'>
    <!-- 收藏 -->
    <div class="collection fl">
      <div v-if="color === '#fff'">
        <img class="collection-img" :src='img2' v-if="curIsCollection" @click.stop="handleCollection('del')"  alt />
        <img class="collection-img" :src='img1' v-else @click.stop="handleCollection('add')"  alt />
      </div>
      <div v-else>
        <img class="collection-img" :src='img4' v-if="curIsCollection" @click.stop="handleCollection('del')"  alt />
        <img class="collection-img" :src='img3' v-else @click.stop="handleCollection('add')"  alt />
      </div>
    </div>
  </div>
</template>

<script>
import collection from "@/lobby_common/mixins_components/collection/index.js";
export default {
  components: {},
  props: [],
  mixins: [collection],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.collection{
  font-size: 24px;
  line-height: 24px;
  cursor: pointer;
  // margin: 0px 4px 0 20px;
}
.collection-img{
  display: block;
  width: 24px;
  height: 20px;
}
</style>
